import type { Component } from "solid-js";

/**
 * TableDate component for consistent date formatting across all tables
 * Displays date in condensed two-row format: MM/DD on line 1, HH:MM on line 2
 */
export const TableDate: Component<{ date: Date | null }> = (props) => {
  const formatDate = () => {
    if (!props.date || !props.date.getTime || Number.isNaN(props.date.getTime())) {
      return "-";
    }

    const date = new Date(props.date);

    // Two-row format: MM/DD \n HH:MM
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${month}/${day}\n${hours}:${minutes}`;
  };

  return <span class="table-date-cell">{formatDate()}</span>;
};
